import styled from "styled-components";
import { Image } from "../../../../../../raw-components/image/image";

export const LiveCasinoGridItemInfobarIconDefaultBox = styled(Image)`
   margin-right: 0.25em;
`;